

















import {Component, Vue} from 'vue-property-decorator';
import HeaderAndCrumbs from '@/components/Views/Home Page/HeaderAndCrumbs.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';
import ServiceListing from '@/components/Views/Home Page/ServiceListing.vue';
import {FeathersVuexFindAll} from '@/utils';
import {groupBy} from 'lodash';
import {nil} from '@/common';
import ServicesPage from '@/components/Pages/Home Page/Services/ServicesPage.vue';

@Component({
    components: {
        ServicesPage,
        HeroImage,
    },
})
export default class ServicesHairAndMakeup extends Vue {
    private header = 'Hair & Makeup';
    private hero1 = 'Hair, Makeup and Everything In-Between At Your Fingertips';
    private heroImage = require('@/assets/hero/hair_and_makeup.jpg');
    private title = 'YOU\'VE GOT BEAUTY, SOPLUSH PROS HAVE IMAGINATION';
    private serviceQuery = null;
    private services: any[] = [];
    private crumbs = [
        {name: 'Home', path: '/'},
        {name: 'Services', path: '/services'},
        {name: 'Hair & Makeup Services', path: '/services/hair-and-makeup-services'},
    ];
    public mounted() {
        this.setServiceQuery();
    }
    public async setServiceQuery() {
        const {ServiceType, Category} = this.$FeathersVuex;
        const serviceTypes = await FeathersVuexFindAll(ServiceType, {});
        const [category] = await FeathersVuexFindAll(Category, {
            query: {
                name: 'Personal',
            },
        });
        this.serviceQuery = {
            serviceTypes: {$in: serviceTypes.map((x) => x._id)},
            category: category._id,
            $sort: {
                displayOrder: 1,
            },
        };
    }
}
